import {Text, Grid, Divider} from "@chakra-ui/core";
import CheckIcon from "@pency/components/icons/CheckCircle";
import { useTranslation } from "~/i18n/hooks";

const PlansFeaturesItem: React.FC<{feature: any}> = ({ feature }) => {
    const t = useTranslation();

    const renderData = (data) => {
        switch (typeof data) {
            case "string":
                return <Text textAlign={"center"} fontSize={{base: "sm", md: "md"}} margin="auto">{t(`${data}`)}</Text>;
            case "number":
                return <Text margin="auto">{t(`${data}`)}</Text>;
            case "boolean":
                if (data === true) {
                    return <CheckIcon margin="auto" width={6} />
                }else if (data === false) {
                    return <Text margin="auto">{" "}</Text>;
                };
            default:
                return <CheckIcon margin="auto" width={6} />
        }
    }

    return (
        <>
            <Grid templateColumns={{base: "1fr repeat(3, 50px)", md: "1fr repeat(3, 250px)"}} gap={6} mt={1} mb={1} alignItems={"center"}>
                <Text>{t(`${feature.title}`)}</Text>
                {renderData(feature.free)}
                {renderData(feature.comercial)}
                {renderData(feature.premium)}
            </Grid>
            <Divider />
        </>
    );
  };
  
  export default PlansFeaturesItem;